import { render, staticRenderFns } from "./DsdInfoForm.vue?vue&type=template&id=241fb260"
import script from "./DsdInfoForm.vue?vue&type=script&lang=js"
export * from "./DsdInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports